import { CardActions, Button, Box } from '@mui/material';
import Header from 'src/shared/components/Header';
import { useStyles } from './styles';
import { useTranslation } from 'react-i18next';
import { type FlexflowEmployeeDataToDisplay } from '../../Contracts/types';
import { FlexflowEmployeeStatusesBeforeActivation } from '../../Contracts/ContractStatusBeforeInvitation';
import { type Employee } from 'src/shared/types/employee';
import { useUpdateFlexflowContractModal } from './hooks';

type SubheaderWithButtonProps = {
  pageTitle?: string;
  data: FlexflowEmployeeDataToDisplay | Employee;
};

const SubheaderWithButton = ({ pageTitle, data }: SubheaderWithButtonProps) => {
  const classes = useStyles();
  const { t } = useTranslation(['flexflow', 'nav']);
  const { handleDisableClick, handleInviteClick, disableButtonLabel, inviteButtonLabel } =
    useUpdateFlexflowContractModal(data);

  const hasInvitationStatus = 'invitationStatus' in data;

  const shouldDisplayDisableButton =
    hasInvitationStatus && data.invitationStatus !== FlexflowEmployeeStatusesBeforeActivation.NOT_INVITED;

  return (
    <div className={classes.wrapper}>
      <Box flexGrow={1}>
        <Header>{pageTitle ?? t('items.manage employees', { ns: 'nav' })}</Header>
      </Box>
      {shouldDisplayDisableButton ? (
        <CardActions classes={{ root: classes.cardActionsRoot }}>
          <Button variant="contained" color="primary" onClick={handleDisableClick} sx={{ minWidth: '150px' }}>
            {disableButtonLabel}
          </Button>
        </CardActions>
      ) : (
        <CardActions classes={{ root: classes.cardActionsRoot }}>
          <Button variant="contained" color="primary" onClick={handleInviteClick} sx={{ minWidth: '150px' }}>
            {inviteButtonLabel}
          </Button>
        </CardActions>
      )}
    </div>
  );
};

export default SubheaderWithButton;
